import { BANNER_NOTICE_VERSION } from "@/core/consent/banner";

/**
 * The notice generation this build ships, passed into the engine as data so the
 * reducer stays pure and a test can exercise a bump by passing a different string.
 *
 * It is the MOUNTED banner's id (`banner.ts` picks the CMP and its generation
 * together), so decisions record under the wording the visitor actually read —
 * never under another CMP's copy id. `Scripts/check-consent-notice-version-lockstep.py`
 * follows this import to find the active id, so the backend constant must move
 * with the banner selection.
 *
 * Committed rather than environment-driven: the id names a specific copy generation,
 * so a deploy-time variable could stamp a generation whose wording was never shown.
 */
export const getCurrentNoticeVersion = (): string => BANNER_NOTICE_VERSION;
